var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaglikKurumlari(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#1EC081"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76 11c0-2.488 2.225-4.505 5.395-4.505l.113.001a5.847 5.847 0 00-3.283-.996c-3.158 0-5.717 2.462-5.717 5.5s2.56 5.5 5.717 5.5a5.848 5.848 0 003.283-.996l-.113.001c-3.17 0-5.395-2.017-5.395-4.505z",
    fill: "#fff"
  })));
}
export default SvgSaglikKurumlari;